import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Optional,
  Renderer2,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';

import { IconName } from '../../icons-container/icons.type';
import { RtInput } from '../../utils/rt-input';

@Component({
  selector: 'rt-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.less'],
  host: {
    '[class.checked]': 'checked',
    '[class.disabled]': 'disabled',
    '[class.has-lens-icon]': 'hasLensIcon',
    '[class.has-no-tb-margin]': 'hasNoTBMargin',
    '[class.has-color-text-color]': 'hasColorTextColor',
    '[class.has-bold-text]': 'hasBoldText',
    '[class.has-align-items-start]': 'hasAlignItemsStart',
    '(click)': 'handleClick($event)',
    '(focus)': 'focus.emit($event)',
    '(blur)': 'blur.emit($event)',
  },
})
export class RadioComponent extends RtInput<string | boolean | null> {
  @Input() public value: string | true = true;
  @Input() public checked: boolean = false;
  @Input() public hasLensIcon: boolean = false;
  @Input() public hasNoTBMargin: boolean = false;
  @Input() public hasColorTextColor: boolean = false;
  @Input() public hasBoldText: boolean = false;
  @Input() public hasAlignItemsStart: boolean = false;

  constructor(
    elementRef: ElementRef,
    renderer2: Renderer2,
    @Optional()
    @Self()
    ngControl: NgControl,
    cdRef: ChangeDetectorRef,
  ) {
    super(elementRef, renderer2, ngControl, cdRef);
  }

  public handleClick($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    if (!this.disabled && !this.readOnly) {
      this.handleChange(!this.checked ? this.value || true : null);
    }
  }

  public getIconName(): IconName {
    // TODO
    return this.hasLensIcon ? <any>'lens' : 'check';
  }

  protected setValue(value: string | boolean): void {
    this.checked = this.value === value;
  }
}
